import { Reveal, Overline, MagicImage } from "./primitives";

const COMMUNITY_IMG = "/images/community.jpg";

export const CommunityReading = () => (
  <>
    <section id="community" data-testid="community-section" className="bg-alabaster py-28 md:py-40">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-6">
          <Reveal><Overline>Community</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Community isn't a bonus.
              <span className="italic text-terracotta"> Community is the method.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-6 font-sans text-lg font-light leading-relaxed text-stonegray">
              <p>Transformation is hard in isolation. In this space, you:</p>
              <ul className="space-y-3">
                {[
                  "Read together and talk honestly about money",
                  "Share ideas and first offers",
                  "Celebrate first customers",
                  "Navigate breakdowns in real time",
                  "Borrow belief from people a few steps ahead",
                ].map((item) => (
                  <li key={item} className="flex items-baseline gap-3">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-ink">
                Often, someone else can see your potential before you can. Let this community hold that vision for you
                until you can hold it for yourself.
              </p>
              <p>
                We also host an ongoing, low-pressure book club with curated reads in money, entrepreneurship, and
                personal growth — recommended, never weaponized as "homework."
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal className="lg:col-span-6" y={50}>
          <MagicImage
            testid="community-image"
            src={COMMUNITY_IMG}
            alt="A community learning and growing together"
            glow="sage"
            speed={60}
            className="aspect-[4/5] w-full"
            imgClassName="rounded-[2px]"
          />
        </Reveal>
      </div>
    </section>
  </>
);
